export default "__VITE_ASSET__LQ103PyJ__";